import {createApp} from 'vue'
import App from './App.vue'
import router from "@/router";

import '@/assets/scss/styles.scss'

import {createPinia} from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import ToastPlugin from "@/components/toast/Tostify";

if (!window.api) {
    alert('Error loading application');
    window.location.href = 'about:blank';
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(ToastPlugin);

app.mount('#app')
